var map = {
	"./3d-glasses-1.png": 320,
	"./3d-glasses-2.png": 489,
	"./3d-glasses-3.png": 490,
	"./3d-glasses-4.png": 491,
	"./action-cam-1.png": 321,
	"./action-cam-2.png": 492,
	"./action-cam-3.png": 493,
	"./action-cam-4.png": 494,
	"./ecommerce-product-img-1.png": 316,
	"./ecommerce-product-img-2.png": 317,
	"./portable-speaker-1.png": 495,
	"./portable-speaker-2.png": 496,
	"./portable-speaker-3.png": 497,
	"./speaker-1.png": 498,
	"./speaker-2.png": 499,
	"./speaker-3.png": 500,
	"./watch-1.png": 312,
	"./watch-2.png": 501,
	"./watch-3.png": 502,
	"./watch-4.png": 503,
	"./watch-card.png": 322,
	"./white-cam-1.png": 313,
	"./white-cam-2.png": 504,
	"./white-cam-3.png": 505,
	"./white-cam-4.png": 506,
	"./white-cam-card.png": 318,
	"./wifi-1.png": 507,
	"./wifi-2.png": 508,
	"./wifi-3.png": 509,
	"./wireless-bluetooth-1.png": 314,
	"./wireless-bluetooth-2.png": 510,
	"./wireless-bluetooth-3.png": 511,
	"./wireless-bluetooth-4.png": 512,
	"./x-box-image-detail-1.png": 513,
	"./x-box-image-detail-2.png": 514,
	"./x-box-image-detail-3.png": 515,
	"./x-box-image-detail-4.png": 516,
	"./xbox-1.png": 311,
	"./xbox-2.png": 517,
	"./xbox-3.png": 518,
	"./xbox-4.png": 519,
	"./xbox-black.png": 520,
	"./xbox-blue.png": 521,
	"./xbox-red.png": 522,
	"./xbox-white.png": 523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 308;